import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { SURVEY_DIRECTION } from '../../common/services/utilities/surveyUtility';
import {
  nextRoute,
  previousRoute,
  surveyQuestionRoute,
  surveySectionRoute,
} from '../../routes';
import SurveyProceed from '../SurveyProceed/SurveyProceed';
import SurveySection from '../SurveySection/SurveySection';
import SurveyRedirectToQuestionInSection from './SurveyRedirectToQuestionInSection/SurveyRedirectToQuestionInSection';
import RedirectIfDivestitureResults from './RedirectIfDivestitureResults/RedirectIfDivestitureResults';

const SurveyRouter = () => {
  const renderSurveySection = ({ match }) => {
    const { questionId } = match.params;

    return <SurveySection questionId={+questionId} />;
  };

  const renderSurveyRedirect = ({ match }) => {
    const { sectionPath } = match.params;

    return (
      <SurveyRedirectToQuestionInSection sectionPath={sectionPath || null} />
    );
  };

  return (
    <>
      <RedirectIfDivestitureResults />
      <Switch>
        <Route exact strict path={nextRoute}>
          <SurveyProceed direction={SURVEY_DIRECTION.NEXT} />
        </Route>
        <Route exact strict path={previousRoute}>
          <SurveyProceed direction={SURVEY_DIRECTION.PREVIOUS} />
        </Route>
        <Route path={surveyQuestionRoute} render={renderSurveySection} />
        <Route path={surveySectionRoute} render={renderSurveyRedirect} />
        <Route render={renderSurveyRedirect} />
      </Switch>
    </>
  );
};

export default SurveyRouter;
